module.exports = __webpack_public_path__ + "media/images/instagram-66beefa4b8c64c5af0cd8978b779963b.png";